import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  handleApiError,
  handleApiResponse,
} from "../../../utils/handleApiError";
import Auth3 from "../../../api/Auth3";

const initialState = {
  isLoading: false,
  error: null,
  success: null,
  companyDetails: null,
};

export const ApiResponse = createAsyncThunk(
  "Api/ApiResponse",
  async ({ email }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Auth3.post(
        `/notifications/newsletter?email=${email}`
      );
      const result = handleApiResponse(response, dispatch);
      if (result.error) return rejectWithValue(result.error);
    } catch (err) {
      const errorMessage = handleApiError(err, dispatch);
      toast.error(err.response.data.error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteNewsletter = createAsyncThunk(
  "Api/deleteNewsletter",
  async ({ email }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Auth3.delete(
        `/notifications/newsletter?email=${email}`
      );
      const result = handleApiResponse(response, dispatch);
      if (result.error) return rejectWithValue(result.error);
    } catch (err) {
      const errorMessage = handleApiError(err, dispatch);
      return rejectWithValue(errorMessage);
    }
  }
);

const ApiSlice = createSlice({
  name: "Api",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ApiResponse.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(ApiResponse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.companyDetails = action.payload;
        toast.success("Email subscribed to the newsletter successfully.");
      })
      .addCase(ApiResponse.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteNewsletter.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteNewsletter.fulfilled, (state) => {
        state.isLoading = false;
        toast.success("Email unsubscribed from the newsletter successfully.");
      })
      .addCase(deleteNewsletter.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default ApiSlice.reducer;
